// src/pages/FlightResults.jsx
// Like LoveHolidays — no standalone flight-only booking.
// Flights are always included in package holidays.
import React from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SearchWidget from "../components/SearchWidget";

const PJS = { fontFamily:"'Plus Jakarta Sans',sans-serif" };
const DS  = { fontFamily:"'DM Sans',sans-serif" };

const AIRLINES = [
  { name:"British Airways",  code:"BA", color:"#075aaa" },
  { name:"easyJet",          code:"EZY",color:"#ff6600" },
  { name:"Ryanair",          code:"FR", color:"#073590" },
  { name:"Jet2",             code:"LS", color:"#e31837" },
  { name:"TUI Airways",      code:"BY", color:"#003580" },
  { name:"Wizz Air",         code:"W6", color:"#c6007e" },
  { name:"Vueling",          code:"VY", color:"#f6c100" },
  { name:"Virgin Atlantic",  code:"VS", color:"#e00000" },
  { name:"Emirates",         code:"EK", color:"#d71a21" },
  { name:"Turkish Airlines", code:"TK", color:"#c70000" },
];

const ROUTES = [
  { from:"London",     to:"Tenerife",      airline:"Ryanair",         hrs:"4h 20m",  popular:true },
  { from:"Manchester", to:"Malaga",         airline:"Jet2",            hrs:"2h 40m",  popular:true },
  { from:"Birmingham", to:"Lanzarote",      airline:"Ryanair",         hrs:"4h 15m",  popular:true },
  { from:"London",     to:"Dubai",          airline:"Emirates",        hrs:"7h 00m",  popular:false},
  { from:"London",     to:"Majorca",        airline:"easyJet",         hrs:"2h 20m",  popular:true },
  { from:"Manchester", to:"Alicante",       airline:"Jet2",            hrs:"2h 30m",  popular:true },
  { from:"London",     to:"Antalya",        airline:"British Airways", hrs:"4h 05m",  popular:true },
  { from:"Edinburgh",  to:"Fuerteventura",  airline:"easyJet",         hrs:"4h 30m",  popular:false},
];

export default function FlightResults() {
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const airports = sp.get("airports") || "";
  const ci = sp.get("checkIn") || "";
  const co = sp.get("checkOut") || "";
  const guests = sp.get("guests") || 2;
  const rooms  = sp.get("rooms")  || 1;

  const goPackage = (dest) => {
    const p = new URLSearchParams({ checkIn:ci||"", checkOut:co||"", guests, rooms, mode:"package", airports });
    if (dest) p.set("city", dest);
    nav(`/hotels?${p}`);
  };

  return (
    <>
      <Navbar />

      {/* Search bar */}
      <div style={{ background:"#f5f3ef",borderBottom:"1px solid #ddd",padding:"14px 20px" }}>
        <div style={{ maxWidth:1280,margin:"0 auto" }}>
          <nav style={{ display:"flex",gap:6,alignItems:"center",marginBottom:10,fontSize:13,flexWrap:"wrap" }}>
            <Link to="/" style={{ color:"#1565C0",textDecoration:"none",...DS }}>Home</Link>
            <span style={{ color:"#ccc" }}>›</span>
            <span style={{ color:"#333",fontWeight:600,...DS }}>Flights</span>
          </nav>
          <SearchWidget defaultTab="flight" />
        </div>
      </div>

      <div style={{ background:"#f7f7f7",minHeight:"70vh",paddingBottom:80 }}>
        <div style={{ maxWidth:900,margin:"0 auto",padding:"40px 20px" }}>

          {/* Main message — like LoveHolidays */}
          <div style={{ background:"#fff",border:"1px solid #e5e5e5",borderRadius:12,padding:"36px 40px",marginBottom:24,textAlign:"center" }}>
            <div style={{ fontSize:48,marginBottom:16 }}>✈</div>
            <h1 style={{ fontSize:26,fontWeight:900,color:"#1a1a1a",marginBottom:12,...PJS }}>
              No flight-only bookings
            </h1>
            <p style={{ fontSize:16,color:"#555",lineHeight:1.75,maxWidth:540,margin:"0 auto 20px",...DS }}>
              There are no flight-only options at Broadway Holidays. Our package holidays include
              flights, which can work out more cost-effective than booking separately.
            </p>
            <p style={{ fontSize:15,color:"#555",lineHeight:1.75,maxWidth:540,margin:"0 auto 28px",...DS }}>
              We offer flights from 28 UK airports with approximately 37 airlines — from budget
              carriers like easyJet and Ryanair for Europe, to British Airways, Emirates and Virgin
              Atlantic for long-haul destinations.
            </p>
            <button onClick={() => goPackage("")}
              style={{ background:"#2E7D32",color:"#fff",border:"none",padding:"15px 36px",borderRadius:9,fontSize:17,fontWeight:800,cursor:"pointer",...PJS,marginBottom:12 }}>
              Search Package Holidays
            </button>
            <br/>
            <a href="tel:02030190055" style={{ fontSize:14,color:"#1565C0",fontWeight:700,textDecoration:"none",...DS }}>
              📞 Or call us on 020 3019 0055
            </a>
          </div>

          {/* Airlines we work with */}
          <div style={{ background:"#fff",border:"1px solid #e5e5e5",borderRadius:12,padding:28,marginBottom:24 }}>
            <h2 style={{ fontSize:19,fontWeight:800,marginBottom:20,...PJS }}></h2>
            <div style={{ display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:12 }}>
              {AIRLINES.map((a,i) => (
                <div key={i} style={{ display:"flex",alignItems:"center",gap:10,background:"#f7f7f7",border:"1px solid #e5e5e5",borderRadius:8,padding:"11px 14px" }}>
                  <div style={{ width:36,height:36,borderRadius:6,background:a.color,color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:900,fontSize:11,flexShrink:0,letterSpacing:.5 }}>
                    {a.code}
                  </div>
                  <span style={{ fontSize:13,color:"#333",fontWeight:600,...DS }}>{a.name}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Popular routes */}
          <div style={{ background:"#fff",border:"1px solid #e5e5e5",borderRadius:12,padding:28 }}>
            <h2 style={{ fontSize:19,fontWeight:800,marginBottom:6,...PJS }}>Popular routes from the UK</h2>
            <p style={{ fontSize:13,color:"#888",marginBottom:18,...DS }}>All flights included as part of a package holiday</p>
            <div style={{ display:"flex",flexDirection:"column",gap:0 }}>
              {ROUTES.map((r,i) => (
                <div key={i}
                  onClick={() => goPackage(r.to)}
                  style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"13px 0",borderBottom:i<ROUTES.length-1?"1px solid #f0f0f0":"none",cursor:"pointer" }}
                  onMouseEnter={e=>e.currentTarget.style.background="#f7f9ff"}
                  onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                  <div style={{ display:"flex",alignItems:"center",gap:14 }}>
                    <span style={{ fontSize:20,flexShrink:0 }}>✈</span>
                    <div>
                      <div style={{ fontWeight:700,fontSize:15,color:"#1a1a1a",...PJS }}>
                        {r.from} → {r.to}
                        {r.popular && <span style={{ marginLeft:8,background:"#e8f5e9",color:"#1B5E20",fontSize:11,padding:"2px 8px",borderRadius:4,fontWeight:700,...DS }}>Popular</span>}
                      </div>
                      <div style={{ fontSize:13,color:"#888",...DS }}>{r.airline} · {r.hrs} · Direct available</div>
                    </div>
                  </div>
                  <div style={{ display:"flex",alignItems:"center",gap:8 }}>
                    <span style={{ fontSize:13,color:"#1565C0",fontWeight:700,...DS }}>View holidays →</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}